import './loadingScreen.css';

function LoadingBCScreen() {
  return (
    <div className="fixed w-screen h-screen -ml-5 -mt-2 z-[100]">
      <div className="w-full h-full flex justify-start items-start bg-transparent flex-col">
        <span className='text-sm ml-8'>Đang tải</span>
        <div className="lds-ellipsis left-6 bottom-8">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingBCScreen;